import { render, staticRenderFns } from "./ValidationSummary.vue?vue&type=template&id=6170cdf8"
import script from "./ValidationSummary.vue?vue&type=script&lang=js"
export * from "./ValidationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports